const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-info-circle",
    x: 0.002,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconB-info-circle1",
    serifid: "iconB-info-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.002,1c-6.076,0 -11,4.924 -11,11c-0,6.076 4.924,11 11,11c6.076,0 11,-4.924 11,-11c-0,-6.076 -4.924,-11 -11,-11Zm-0,19.938c-4.929,0 -8.938,-4.01 -8.938,-8.938c0.001,-4.928 4.009,-8.937 8.938,-8.937c4.929,0 8.938,4.009 8.938,8.937c-0.001,4.928 -4.009,8.938 -8.938,8.938Zm1.719,-5.5l-0.688,0l-0,-3.782c-0,-0.567 -0.46,-1.031 -1.031,-1.031l-1.375,0c-0.567,0 -1.031,0.464 -1.031,1.031c-0,0.567 0.464,1.032 1.031,1.032l0.344,0l-0,2.75l-0.688,0c-0.567,0 -1.031,0.464 -1.031,1.031c-0,0.567 0.464,1.031 1.031,1.031l3.438,0c0.569,0 1.031,-0.462 1.031,-1.031c-0,-0.57 -0.46,-1.031 -1.031,-1.031Zm-1.719,-6.188c0.759,0 1.375,-0.616 1.375,-1.375c-0,-0.759 -0.616,-1.375 -1.375,-1.375c-0.759,0 -1.375,0.614 -1.375,1.375c-0,0.761 0.614,1.375 1.375,1.375Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBInfoCircle);
export default __webpack_public_path__ + "static/media/iconB-info-circle.f75681aef1675517df8d38141a0851c6.svg";
export { ForwardRef as ReactComponent };